import React, { useCallback, useMemo } from 'react';

import { Flex, Grid, GridItem } from '@chakra-ui/react';
import { updateOKR } from 'components/RabbitOKRCreationPanel/OKRCreationPanelSlice';
import { updateLocalStateValues } from 'components/RabbitOKRSidePanel/KRslice';
import { OKRVisibilityComponent } from 'components/RabbitOKRSidePanel/PrimaryPanel/Sections/Details/OKRVisibility';
import { useSelector, useDispatch } from 'react-redux';
import { kRDrawerSelector } from 'selectors/kRDrawer';
import { okrCreationPanelStateSelector } from 'selectors/okrCreationPanelSelector';

import { PrivateObjective } from 'assets/assetsV1/iconComponents';

import { isMobileView } from 'constants/isMobileView';

import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

interface Props {
  isEditOKR?: boolean;
}

const VisibilitySection = ({ isEditOKR = false }: Props) => {
  const dispatch = useDispatch();
  const createOKRDetails = useSelector(okrCreationPanelStateSelector);
  const editOKRSavedDetails = useSelector(kRDrawerSelector);
  const editOKRDetails = useMemo(
    () => ({ ...editOKRSavedDetails, ...editOKRSavedDetails.localStateValues }),
    [editOKRSavedDetails]
  );
  const okrDetails = isEditOKR ? editOKRDetails : createOKRDetails;

  const { visibilityType } = okrDetails;

  const onChange = useCallback(
    (updates) => {
      dispatch(isEditOKR ? updateLocalStateValues(updates) : updateOKR(updates));
    },
    [dispatch, isEditOKR]
  );

  return (
    <Grid gridTemplateColumns={isMobileView() ? '25% 4% 71%' : '20% 4% 76%'} alignItems="center" mb="16px">
      <GridItem>
        <TextLabel color="text.g2">Visibility:</TextLabel>
      </GridItem>
      {/* For spacing after first column */}
      <GridItem />
      <GridItem>
        <OKRVisibilityComponent
          visibilityType={visibilityType}
          onChange={(visibilityType) => onChange({ visibilityType: visibilityType?.value })}
          renderControlItem={(menuItem) => (
            <Flex alignItems="center">
              <PrivateObjective transform="rotate(0deg) !important" boxSize="18px" />
              <TextBodyMedium ml="8px !important">{menuItem?.label}</TextBodyMedium>
            </Flex>
          )}
          isReadOnly={false}
        />
      </GridItem>
    </Grid>
  );
};

export { VisibilitySection };
